<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="用户账号：" prop="userName">
            <el-input style="width: 400px;" v-model="ruleForm.userName" placeholder="请输入用户账号"></el-input>
          </el-form-item>
          <el-form-item v-if="dataId == ''" label="用户密码：" prop="userPassword">
            <el-input style="width: 400px;" type="password" v-model="ruleForm.userPassword" placeholder="请输入用户密码"></el-input>
          </el-form-item>
          <el-form-item label="用户昵称：" prop="nickName">
            <el-input style="width: 400px;" v-model="ruleForm.nickName" placeholder="请输入用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="角色（权限）：" prop="roleIdList">
            <el-select style="width: 400px;" v-model="ruleForm.roleIdList" multiple collapse-tags placeholder="请选择">
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#409EFF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveShopUser, fetchShopUserDetailById, updateShopUser, queryAllRoleList } from '@/api/shop'
export default {
  name: 'ShopAdminAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token: sessionStorage.getItem('token'),
      dataId: this.$route.query.dataId,
      ruleForm: {
        userName: '',
        userPassword: '',
        nickName: '',
        roleIdList: [],
        status: false
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户账号', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请输入用户密码', trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '请输入用户昵称', trigger: 'blur' }
        ],
        roleIdList: [
          { required: true, message: '请选择角色', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    that.roleInfoFun();
    if (this.dataId != '') {
      fetchShopUserDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.userName = data.userName
          that.ruleForm.nickName = data.nickName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.roleIdList = data.roleIdList
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 角色数据
    roleInfoFun(){
      var that = this;
      queryAllRoleList().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          that.roleList = data;
        }
      });
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let userName = that.ruleForm.userName
      let userPassword = that.ruleForm.userPassword
      let nickName = that.ruleForm.nickName
      var roleIdList = that.ruleForm.roleIdList
      let status = that.ruleForm.status ? 1 : 0
      if (userName === '') {
        this.$message.error('请输入用户账号')
        return false
      }
      if (userPassword === '' && dataId == '') {
        this.$message.error('请输入用户密码')
        return false
      }
      if (nickName === '') {
        this.$message.error('请输入用户昵称')
        return false
      }
      if (roleIdList.length === 0) {
        this.$message.error('请选择角色（权限）')
        return false
      }
      let passData = {
        userName: userName, nickName: nickName, status: status, roleIdList: roleIdList
      }
      if (dataId !== '') {
        passData.id = dataId
        updateShopUser(passData).then((res) => {
          that.backDataFun(res)
        })
      } else {
        passData.userPassword = userPassword
        saveShopUser(passData).then((res) => {
          that.backDataFun(res)
        })
      }
    },
    backDataFun (res) {
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/shop/admin/Add.vue